angular.module('unergie.main')
.factory('MetaWatcher', ($q) => {
    const loggerEnabled = false
    const watchers = {}

    const notif = (action, payload, sync) => {
        if (watchers[action]) {
            const promises = []
            _.each(watchers[action], (callback, watcherId) => {
                promises.push(callback(payload))
            })
            if (loggerEnabled) {
                console.group('MetaWatcher')
                // console.groupCollapsed('MetaWatcher', action)
                console.log('%cACTION  ', 'color: #c2395c; font-weight: bold;', action, payload)
                console.log('%cWATCHER ', 'color: #009d6b; font-weight: bold;', watchers[action] ? _.keys(watchers[action]) : '')
                console.groupEnd()
            }
            if (sync) {
                return $q.all(promises)
            }
        }
    }

    const watch = function (action, watcherId, scope, callback) {
        watchers[action] = watchers[action] || {}
        const sym = Symbol(callback)
        callback.sym = sym
        watchers[action][watcherId] = callback

        if (scope) {
            scope.$on('$destroy', () => {
                if (watchers[action][watcherId].sym === sym) { // to be sure we are removing the callback that was added (if replaced for instance)
                    delete watchers[action][watcherId]
                }
            })
        }
        if (loggerEnabled) {
            console.log('MetaWatcher Subscribe: %cACTION %s %cWATCHER %s', 'color: #c2395c; font-weight: bold;', action, 'color: #009d6b; font-weight: bold;', watcherId)
        }
    }

    return {
        notif,
        watch,
    }
})
